"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUserEvent = exports.saveSocketUserEvent = exports.initWebsocket = exports.getLendingTreeBorrower = exports.getAppAffiliateTracking = exports.getAffiliatePrepopData = exports.getAffiliateOfferPrepopData = exports.clearData = exports.SOCKET_CONNECT = exports.SAVE_USER_EVENT = exports.SAVE_SOCKET_USER_EVENT = exports.GET_LENDING_TREE_BORROWER = exports.GET_APP_AFFILIATE_TRACKING = exports.GET_AFFILIATE_PREPOP_DATA = exports.GET_AFFILIATE_OFFER_PREPOP_DATA = exports.CLEAR_PREPOP_DATA = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _reduxActions = require("redux-actions");

var _httpActions = require("./http-actions");

var EXTERNAL_CONTEXT = '/affiliate/external';
var AFFILIATE_OFFER_CONTEXT = '/a/external';
var SECURE_CONTEXT = '/affiliate/secure';
var SOCKET_CONNECT = 'AFFILIATE::SOCKET_CONNECT';
exports.SOCKET_CONNECT = SOCKET_CONNECT;
var GET_APP_AFFILIATE_TRACKING = 'AFFILIATE::GET_APP_AFFILIATE_TRACKING';
exports.GET_APP_AFFILIATE_TRACKING = GET_APP_AFFILIATE_TRACKING;
var GET_LENDING_TREE_BORROWER = 'AFFILIATE::GET_LENDING_TREE_BORROWER';
exports.GET_LENDING_TREE_BORROWER = GET_LENDING_TREE_BORROWER;
var SAVE_SOCKET_USER_EVENT = 'AFFILIATE::SAVE_SOCKET_USER_EVENT';
exports.SAVE_SOCKET_USER_EVENT = SAVE_SOCKET_USER_EVENT;
var SAVE_USER_EVENT = 'AFFILIATE::SAVE_USER_EVENT';
exports.SAVE_USER_EVENT = SAVE_USER_EVENT;
var GET_AFFILIATE_PREPOP_DATA = 'AFFILIATE::GET_AFFILIATE_PREPOP_DATA';
exports.GET_AFFILIATE_PREPOP_DATA = GET_AFFILIATE_PREPOP_DATA;
var GET_AFFILIATE_OFFER_PREPOP_DATA = 'AFFILIATE::GET_AFFILIATE_OFFER_PREPOP_DATA';
exports.GET_AFFILIATE_OFFER_PREPOP_DATA = GET_AFFILIATE_OFFER_PREPOP_DATA;
var CLEAR_PREPOP_DATA = 'AFFILIATE::CLEAR_PREPOP_DATA';
exports.CLEAR_PREPOP_DATA = CLEAR_PREPOP_DATA;
var initWebsocket = (0, _reduxActions.createAction)(SOCKET_CONNECT);
exports.initWebsocket = initWebsocket;
var saveSocketUserEvent = (0, _reduxActions.createAction)(SAVE_SOCKET_USER_EVENT);
exports.saveSocketUserEvent = saveSocketUserEvent;

var getAppAffiliateTracking = function getAppAffiliateTracking(applicationUuid) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_APP_AFFILIATE_TRACKING, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURE_CONTEXT, "/user-event/tracking/application/").concat(applicationUuid), null, null, false));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getAppAffiliateTracking = getAppAffiliateTracking;
var clearData = (0, _reduxActions.createAction)(CLEAR_PREPOP_DATA);
exports.clearData = clearData;

var saveUserEvent = function saveUserEvent(data) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPost)(SAVE_USER_EVENT, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(SECURE_CONTEXT, "/user-event"), data));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}; // { lastName, last4Ssn, zipCode }


exports.saveUserEvent = saveUserEvent;

var getLendingTreeBorrower = function getLendingTreeBorrower(data) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxPost)(GET_LENDING_TREE_BORROWER, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(EXTERNAL_CONTEXT, "/lending-tree/borrower"), data));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getLendingTreeBorrower = getLendingTreeBorrower;

var getAffiliatePrepopData = function getAffiliatePrepopData() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_AFFILIATE_PREPOP_DATA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(EXTERNAL_CONTEXT, "/prepop")));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getAffiliatePrepopData = getAffiliatePrepopData;

var getAffiliateOfferPrepopData = function getAffiliateOfferPrepopData() {
  return /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", (0, _ajax.ajaxGet)(GET_AFFILIATE_OFFER_PREPOP_DATA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(AFFILIATE_OFFER_CONTEXT, "/prepop")));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};

exports.getAffiliateOfferPrepopData = getAffiliateOfferPrepopData;